import { Controller, type Control, type FieldPath, type FieldValues } from "react-hook-form";
import type { InputHTMLAttributes } from "react";
import { Input } from "./input";
import { toTitleCase, toUpperNoAccents, onlyDigits } from "@/lib/textFilters";

type BaseProps<T extends FieldValues> = {
  control: Control<T>;
  name: FieldPath<T>;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange" | "name">;

function filterInput<T extends FieldValues>(
  transform: (s: string) => string
) {
  return function InputWithFilter({ control, name, ...rest }: BaseProps<T>) {
    return (
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Input
            {...rest}
            name={field.name}
            ref={field.ref}
            value={(field.value as string | number | null | undefined) ?? ""}
            onBlur={field.onBlur}
            onChange={(e) => {
              const v = transform(e.target.value);
              field.onChange(v);
            }}
          />
        )}
      />
    );
  };
}

/** Title Case con conectores en minúscula, sin acentos. */
export const TitleCaseInput = filterInput(toTitleCase);

/** MAYÚSCULAS sin acentos (RFC, CURP, códigos). */
export const UpperInput = filterInput(toUpperNoAccents);

/** Solo dígitos (CP, teléfono). */
export const DigitsInput = filterInput(onlyDigits);
